/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
    object, string, func,
} from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import CloseIcon from '@material-ui/icons/Close';
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import ReactMarkdown from 'react-markdown';
import DialogContent from '@material-ui/core/DialogContent';
import { useUIDSeed } from 'react-uid';
import ReactHtmlParser from 'react-html-parser';
import { selectedSkuType, skuDataType, UpsellType } from '../common/types';
import ClubPDPAltImageSlider from '../GraphqlClubPDPImage/ClubPDPAltImageSlider';

const styles = (theme) => ({
    clubSelectionBox: {
        width: '115px',
        height: '115px',
        textAlign: 'center',
        display: 'inline-block',
        marginRight: 10,
        position: 'relative',
        border: '1.5px solid rgba(191, 191, 191, 1)',
        cursor: 'pointer',
        '&:hover': {
            border: '1.5px solid rgba(0, 0, 0, 1)',
        },
    },
    clubSelectionBoxSelected: {
        width: '115px',
        border: '1.5px solid rgba(0,0,0, 1)',
        cursor: 'pointer',
        height: '115px',
        color: theme.palette.cms?.primary_font_color || '#ffffff',
        display: 'inline-block',
        background: theme.palette.common?.black || '#000',
        position: 'relative',
        textAlign: 'center',
        marginRight: '10px',
        '&:hover': {
            border: '1.5px solid rgba(0, 0, 0, 1)',
        },
        '&:focus-visible': {
            outline: 'none',
        },
    },
    relative: {
        position: 'relative',
    },
    clubTagline: {
        position: 'absolute',
        backgroundColor: theme.palette.grey?.['300'] || '#E0E0E0',
        color: theme.palette.text?.primary || '#000',
        left: '-1px',
        padding: '3px',
        top: '8px',
        fontWeight: '600',
        fontStyle: 'italic',
        fontSize: '12px',
    },
    clubPrice: {
        margin: '10px 0',
        fontSize: '18px',
        fontWeight: '700',
        marginTop: '40px',
    },
    clubDuration: {
        margin: '10px 0',
        fontSize: '16px',
    },
    monthContainer: {
        display: 'flex',
    },
    clubSelectedMonth: {
        border: `1px solid ${theme.palette.cms?.clubSelectedMonth || '#161616'} !important`,
        backgroundColor: `${theme.palette.cms?.clubSelectedMonth || '#161616'} !important`,
        color: `${theme.palette.cms?.primary_font_color || '#ffffff'} !important`,
        '&:focus-visible': {
            outline: 'auto 1px -webkit-focus-ring-color',
        },
    },
    fadeClubMonth: {
        overflow: 'auto',
        width: '48px',
        border: `1px solid ${theme.palette.cms?.checkbox || '#797979'}`,
        height: '48px',
        alignItems: 'center',
        marginRight: '12px',
        justifyContent: 'center',
        display: 'flex',
        borderRadius: '50%',
        cursor: 'pointer',
        textAlign: 'center',
        backgroundColor: theme.palette.cms?.primary_font_color || '#ffffff',
        opacity: 0.4,
        '&:focus-visible': {
            outline: 'auto 1px -webkit-focus-ring-color',
        },
    },
    clubmonth: {
        overflow: 'auto',
        width: '48px',
        border: `1px solid ${theme.palette.cms?.checkbox || '#797979'}`,
        height: '48px',
        alignItems: 'center',
        marginRight: '12px',
        justifyContent: 'center',
        display: 'flex',
        borderRadius: '50%',
        cursor: 'pointer',
        textAlign: 'center',
        backgroundColor: theme.palette.cms?.primary_font_color || '#ffffff',
        '&:hover': {
            border: '1px solid rgba(0, 0, 0, 1)',
        },
        '&:focus-visible': {
            outline: 'auto 1px -webkit-focus-ring-color',
        },
    },
    upsellContainer: {
        display: 'flex',
        maxWidth: '100%',
    },
    upsellsLabelItalic: {
        fontStyle: 'italic',
        color: theme.palette.cms?.clubAvailablility || '#404040',
    },
    blockRemove: {
        background: `${theme.palette.primaryButton || '#a1001a'}!important`,
    },
    upsellBox: {
        width: 144,
        position: 'relative',
        marginRight: 35,
        '& > img': {
            maxWidth: '100%',
        },
        cursor: 'pointer',
        '&:hover span.unselected': {
            background: theme.palette.primaryButton || '#a1001a',
            '& span.priceBlock': {
                display: 'none !important',
            },
            '& span.seeMore': {
                display: 'block',
            },
        },
        '& span.seeMore': {
            display: 'none',
        },
    },
    upsellPriceTag: {
        position: 'absolute',
        right: 0,
        left: 0,
        bottom: 0,
        backgroundColor: theme.palette.cms?.secondary || '#2f2f2f',
        boxSizing: 'border-box',
        color: theme.palette.cms?.primary_font_color || '#ffffff',
        padding: 2,
        textAlign: 'center',
    },
    prevLink: {
        transform: 'rotate(-90deg)',
        backgroundColor: 'rgba(255, 255, 255, 0)',
        boxSizing: 'border-box',
        color: theme.palette.desktopHeaderMenu?.text || '#333333',
        textAlign: 'center',
        lineHeight: 'normal',
        '&:focus-visible': {
            outline: 'auto 1px -webkit-focus-ring-color',
        },
    },
    nextLink: {
        transform: 'rotate(90deg)',
        backgroundColor: 'rgba(255, 255, 255, 0)',
        boxSizing: 'border-box',
        color: theme.palette.desktopHeaderMenu?.text || '#333333',
        textAlign: 'center',
        lineHeight: 'normal',
        '&:focus-visible': {
            outline: 'auto 1px -webkit-focus-ring-color',
        },
    },
    flexContainer: {
        display: 'flex',
    },
    productImageWrapperMonth: {
        flex: '1 1 auto',
        maxWidth: '300px',
        minWidth: '300px',
        height: '100%',
        position: 'relative',
        [theme.breakpoints.down('md')]: {
            order: '1',
        },
    },
    monthDescriptionSummury: {
        minWidth: '500px',
        marginLeft: '3rem',
        [theme.breakpoints.down('md')]: {
            margin: '0px 3rem 0px 0px',
        },
    },
    productImage: {
        width: '100%',
        height: 'auto',
        [theme.breakpoints.down('md')]: {
            height: 'auto',
        },
    },
    closeIcon: {
        position: 'absolute',
        top: '13px',
        right: '13px',
        cursor: 'pointer',
    },
    addToCartButtonFullWidth: {
        color: theme.palette.white,
        backgroundColor: `${theme.palette.primaryButton} !important`,
        fontFamily: theme.typography.fontFamily,
        boxSizing: 'border-box',
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale',
        fontWeight: '700',
        width: '100%',
        height: '50px',
        fontSize: '1em',
        textTransform: 'uppercase',
        borderRadius: '28px',
        lineHeight: '1.46em',
        padding: '7px 24px 5px 24px',
    },
    clubUpsellSelected: {
        background: theme.palette.cms?.selectedUpsellBackground || 'rgba(0,0,0,0.7)',
        position: 'absolute',
        top: '0',
        left: '0',
        right: '0',
        bottom: '0',
        '& .delete-box': {
            display: 'none',
        },
        '&:hover': {
            '& .selected-box': {
                display: 'none',
            },
            '& .delete-box': {
                display: 'block',
            },
        },
    },
    block: {
        display: 'block',
        color: theme.palette.cms?.primary_font_color || '#ffffff',
        textAlign: 'center',
        '& img': {
            marginTop: 20,
        },
        '& img.remove': {
            marginTop: 50,
        },
    },
    forMonthClub: {
        width: '80%',
        [theme.breakpoints.down('md')]: {
            width: '92%',
        },
    },
    sliderContainer: {
        '& .slick-prev, & .slick-next': {
            backgroundColor: 'rgba(255, 255, 255, 0)',
            boxSizing: 'border-box',
            color: theme.palette.desktopHeaderMenu?.text || '#333333',
            textAlign: 'center',
            lineHeight: 'normal',
            width: '20px',
            '&:focus-visible': {
                outline: 'auto 1px -webkit-focus-ring-color',
            },
        },
        '& .slick-prev': {
            left: '0px',
            transform: 'rotate(-90deg)',
        },
        '& .slick-next': {
            transform: 'rotate(90deg)',
            right: '8px',
            [theme.breakpoints.down(1366)]: {
                right: '3px',
            },
            [theme.breakpoints.down(1024)]: {
                right: '0px',
            },
        },
        '& .slick-list': {
            width: '92%',
        },
    },
});

const ClubSelectionDesktop = ({
    classes,
    skuData,
    selectedSku,
    renderSkuPrice,
    skuMonths,
    changeClubMonth,
    changeClubLength,
    tracker,
    clubUpsells,
    changeClubUpsell,
    selectedClubUpsells,
}) => {
    const skuCollector = [];
    const seed = useUIDSeed();
    const [showModal, setShowModal] = useState(false);
    const [showUpsell, setShowUpsell] = useState(null);

    const cdnLink = 'https://cdn1.harryanddavid.com/wcsstore/HarryAndDavid/images/catalog/'; // will remove after GQL ready
    const getSlides = () => {
        const slides = [];

        Object.keys(skuMonths).forEach((month) => {
            const monthShort = month.substr(0, 3);
            const currentClubLength = Number(selectedSku.clubLength) || 0;
            const nextMonthSameLength = skuMonths[month].findIndex((monthSku) => Number(monthSku.clubLength) === currentClubLength);
            let changeClubMonthLength = 0;
            if (nextMonthSameLength >= 0) {
                changeClubMonthLength = nextMonthSameLength;
            }
            slides.push(
                <div
                    data-fade={skuMonths[month]?.[0]?.fade}
                    data-testid={`next-selected-${month}-${changeClubMonthLength}-${skuMonths[month]?.[changeClubMonthLength]?.id}`}
                    className={`${skuMonths[month]?.[0]?.isSelectedMonth ? classes.clubSelectedMonth : ''} ${skuMonths[month]?.[0]?.fade ? classes.fadeClubMonth : classes.clubmonth}`}
                    key={seed(month)}
                    onClick={() => {
                        changeClubMonth(skuMonths[month]?.[changeClubMonthLength]);
                    }}
                    data-year={skuMonths[month]?.[0]?.date?.year}
                    tabIndex="0"
                    role="link"
                    onKeyPress={() => { }}
                >
                    {monthShort}
                </div>,
            );
        });
        return slides;
    };

    return (
        <>
            <h3>Club Length</h3>
            <div className={classes.clubSelectionContainer}>
                {skuData.map((sku) => {
                    if (!sku?.clubLength || !sku?.isSelectedMonth) {
                        return null;
                    }
                    if (((skuCollector || []).filter((skuList) => skuList?.length === sku?.clubLength).length)) {
                        return null;
                    }
                    if (selectedClubUpsells) {
                        skuCollector.push({
                            month: sku?.date?.month,
                            length: sku?.clubLength,
                            id: sku?.partNumber,
                        });
                    }
                    return (
                        <div
                            data-id={sku?.legacyId}
                            data-testid={`sku-list-${sku?.legacyId}`}
                            data-partnumber={sku?.partNumber}
                            data-selected-month={sku?.date?.month}
                            className={selectedSku.id === sku.id ? classes.clubSelectionBoxSelected : classes.clubSelectionBox}
                            key={seed(sku)}
                            onKeyPress={() => { }}
                            onClick={() => {
                                changeClubLength((sku.partNumber || sku.id), sku.id);
                                tracker(sku);
                            }}
                            tabIndex="0"
                            role="link"
                        >
                            {sku?.tagline && (<span className={classes.clubTagline}>{sku?.tagline}</span>)}
                            <p className={classes.clubPrice}>{renderSkuPrice(sku, true)}</p>
                            <p className={classes.clubDuration}>{sku?.clubLength} Months</p>
                        </div>
                    );
                })}
            </div>
            <h4>Starting Month</h4>
            <div className={classes.forMonthClub}>
                <ClubPDPAltImageSlider
                    itemsToShow={8}
                    itemsPerSlide={8}
                    data={getSlides()}
                    nextArrow="https://cdn1.harryanddavid.com/wcsstore/HarryAndDavid/images/normal_u2556.svg"
                    prevArrow="https://cdn1.harryanddavid.com/wcsstore/HarryAndDavid/images/normal_u2556.svg"
                    style={classes.sliderContainer}
                />
            </div>
            <div className={classes.monthContainer} />
            <>
                <Dialog
                    open={showModal}
                    maxWidth="md"
                    onClose={() => { setShowModal(false); }}
                >
                    <DialogTitle>
                        <CloseIcon data-testid="close-upsell-modal" onClick={() => { setShowModal(false); }} className={classes.closeIcon} />
                    </DialogTitle>
                    <DialogContent>
                        {showUpsell && (
                            <div data-testid={`showing-upsell-detail-${showUpsell.partNumber}`} className={classes.flexContainer}>
                                <div className={classes.productImageWrapperMonth}>
                                    <img
                                        className={classes.productImage}
                                        src={`${cdnLink}${showUpsell.image?.name}${'x.jpg'}`}
                                        alt={ReactHtmlParser(showUpsell.name)}
                                    />
                                </div>
                                <div className={classes.monthDescriptionSummury}>
                                    <h2>{ReactHtmlParser(showUpsell.name)}</h2>
                                    <p>
                                        <ReactMarkdown
                                            source={showUpsell.longDescription || ''}
                                            escapeHtml={false}
                                        />
                                        <ReactMarkdown
                                            source={showUpsell.productContents || ''}
                                            escapeHtml={false}
                                        />
                                    </p>
                                    <Button
                                        onClick={() => {
                                            changeClubUpsell(showUpsell.partNumber);
                                            setShowModal(false);
                                        }}
                                        className={classes.addToCartButtonFullWidth}
                                        variant="contained"
                                    >
                                        ADD ${showUpsell.upSellCalculatedPrice} TO UPGRADE
                                    </Button>
                                </div>
                            </div>
                        )}
                    </DialogContent>
                </Dialog>
            </>
            {clubUpsells.length > 0 && (
                <p className={classes.upsellsLabel}>Swap your first month&apos;s delivery to a premium gift <span className={classes.upsellsLabelItalic}>(optional)</span></p>
            )}
            <div className={classes.upsellContainer}>
                {(clubUpsells || []).map((upsell) => upsell?.upSellDisplayPrice && (
                    <div
                        data-selected={selectedClubUpsells}
                        className={classes.upsellBox}
                        data-id={upsell?.partNumber}
                        data-testid={`block-upsell-${upsell?.partNumber}`}
                        key={seed(upsell)}
                        onKeyPress={() => { }}
                        onClick={() => {
                            if ((selectedClubUpsells === upsell?.partNumber)) {
                                changeClubUpsell(showUpsell.partNumber, true);
                            } else {
                                setShowModal(true);
                                setShowUpsell(upsell);
                            }
                        }}
                        tabIndex="0"
                        role="link"
                    >
                        {(selectedClubUpsells === upsell?.partNumber) ? (
                            <>
                                <img src={`${cdnLink}${upsell?.image?.name}x.jpg?width=144&height=158&auto=webp`} alt={upsell.name} />
                                <span className={classes.upsellPriceTag}>
                                    <span className="priceBlock">+ ${upsell?.upSellCalculatedPrice}</span>
                                </span>
                                <span className={classes.clubUpsellSelected}>
                                    <span className="selected-box">
                                        <span className={classes.block}>
                                            <img alt="Selected" src="https://cdn1.harryanddavid.com/wcsstore/HarryAndDavid/images/path_2_copy_3_u119.svg" />
                                        </span>
                                        <span className={classes.block}>Selected</span>
                                    </span>
                                    <span className="delete-box">
                                        <span className={classes.block}>
                                            <img className="remove" alt="Remove" src="https://cdn1.harryanddavid.com/wcsstore/HarryAndDavid/images/shape_u105.svg" />
                                        </span>
                                        <span className={`${classes.blockRemove} ${classes.upsellPriceTag}`}>Remove</span>
                                    </span>
                                </span>
                            </>
                        ) : (
                            <>
                                <img src={`${cdnLink}${upsell?.image?.name}x.jpg?width=144&height=158&auto=webp`} alt={upsell.name} />
                                <span className={`${classes.upsellPriceTag} unselected`}>
                                    <span className="priceBlock">+ ${upsell?.upSellCalculatedPrice}</span>
                                    <span className="seeMore">See Details</span>
                                </span>
                            </>
                        )}
                    </div>
                ))}
            </div>
        </>
    );
};

ClubSelectionDesktop.defaultProps = {
    renderSkuPrice: () => { },
    skuMonths: {},
    clubUpsells: [],
    changeClubMonth: () => { },
    tracker: () => { },
    changeClubLength: () => { },
    changeClubUpsell: () => { },
    classes: {},
    selectedClubUpsells: null,
};

ClubSelectionDesktop.propTypes = {
    classes: object,
    renderSkuPrice: func,
    changeClubUpsell: func,
    changeClubMonth: func,
    skuData: skuDataType.isRequired,
    selectedSku: selectedSkuType.isRequired,
    skuMonths: object, // the object contains dynamic keys
    tracker: func,
    changeClubLength: func,
    selectedClubUpsells: string,
    clubUpsells: UpsellType,
};

export default withStyles(styles)(ClubSelectionDesktop);
